export interface WebsiteIdea {
  id: string;
  slug: string;
  title: string;
  status: "draft" | "active" | "done" | "archived";
  priority: "high" | "medium" | "low";
  tags: string[];
  folder: string;
  body: string;
  excerpt: string;
  createdAt: string;
  updatedAt: string;
}

export interface IdeasResponse {
  ideas: WebsiteIdea[];
}

export async function fetchIdeas(): Promise<IdeasResponse> {
  const res = await fetch("/api/ideas");
  if (!res.ok) throw new Error(`Failed to load ideas (${res.status})`);
  return res.json();
}

export async function fetchAllIdeas(): Promise<IdeasResponse> {
  const res = await fetch("/api/ideas?all=true");
  if (!res.ok) throw new Error(`Failed to load ideas (${res.status})`);
  return res.json();
}

export async function createIdea(data: {
  title: string;
  body?: string;
  priority?: string;
}): Promise<{ success: boolean; slug: string }> {
  const res = await fetch("/api/ideas", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Failed to create idea: ${res.statusText}`);
  return res.json();
}
